import React from 'react'
import { Form, Input, Row, Col, Button } from 'antd'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const { TextArea } = Input

const StyledForm = styled(Form)`
  width: 100%;
`

const StyledButton = styled(Button)`
  &.ant-btn-primary {
    border: 0px !important;
    border-radius: 30px !important;
    background-image: linear-gradient(70.98762166149521deg, #008080 0%, #02b7b7 100%) !important;
    box-sizing: border-box !important;
    color: #ffffff !important;
    text-align: center;
    line-height: normal !important;

    &:hover {
      box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.35) !important;
      background-image: linear-gradient(70.98762166149521deg, #008080 0%, #02b7b7 100%) !important;
    }
  }
`

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 15px;
  .ant-form-item-label > label {
    font-weight: 600;
    padding-bottom: 0.2rem !important;
  }
`

/**
 * ContactForm component for subscription contact form
 * @param {Object} props - Component props
 * @param {Function} props.onSubmit - Function to handle form submission
 * @returns {JSX.Element} Rendered contact form
 */
const ContactForm = ({ onSubmit }) => {
  const { t } = useTranslation()

  return (
    <StyledForm onFinish={values => onSubmit(values)} layout="vertical">
      <Row gutter={16}>
        <Col span={12}>
          <StyledFormItem
            label={t('subscriptions.form.name')}
            name="name"
            rules={[
              {
                required: true,
                message: t('subscriptions.validation.nameRequired'),
              },
            ]}
          >
            <Input placeholder={t('subscriptions.form.name')} size="large" />
          </StyledFormItem>
        </Col>
        <Col span={12}>
          <StyledFormItem
            label={t('subscriptions.form.lastName')}
            name="lastName"
            rules={[
              {
                required: true,
                message: t('subscriptions.validation.lastNameRequired'),
              },
            ]}
          >
            <Input placeholder={t('subscriptions.form.lastName')} size="large" />
          </StyledFormItem>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <StyledFormItem
            label={t('subscriptions.form.organization')}
            name="organization"
            rules={[
              {
                required: true,
                message: t('subscriptions.validation.organizationRequired'),
              },
            ]}
          >
            <Input placeholder={t('subscriptions.form.organization')} size="large" />
          </StyledFormItem>
        </Col>
        <Col span={12}>
          <StyledFormItem
            label={t('subscriptions.form.jobTitle')}
            name="jobTitle"
            rules={[
              {
                required: true,
                message: t('subscriptions.validation.jobTitleRequired'),
              },
            ]}
          >
            <Input placeholder={t('subscriptions.form.jobTitle')} size="large" />
          </StyledFormItem>
        </Col>
      </Row>

      <StyledFormItem
        label={t('subscriptions.form.email')}
        name="email"
        rules={[
          {
            required: true,
            message: t('subscriptions.validation.emailRequired'),
          },
          {
            type: 'email',
            message: t('subscriptions.form.emailInvalid'),
          },
        ]}
        validateTrigger="onBlur"
      >
        <Input placeholder={t('subscriptions.form.email')} size="large" />
      </StyledFormItem>

      <StyledFormItem
        label={t('subscriptions.form.phone')}
        name="phone"
        rules={[
          {
            pattern: /^[0-9]*$/,
            message: t('subscriptions.form.phoneInvalid'),
          },
        ]}
      >
        <Input type="number" placeholder={t('subscriptions.form.phone')} size="large" />
      </StyledFormItem>

      <StyledFormItem label={t('subscriptions.form.help')} name="message">
        <TextArea rows={4} placeholder={t('subscriptions.form.message')} />
      </StyledFormItem>

      <StyledFormItem style={{ marginBottom: 0 }}>
        <StyledButton
          type="primary"
          htmlType="submit"
          style={{ width: '100%', alignSelf: 'center' }}
          size="large"
        >
          {t('subscriptions.form.send')}
        </StyledButton>
      </StyledFormItem>
    </StyledForm>
  )
}

ContactForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default ContactForm
